import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import LeagueSidebar from "../../components/league/LeagueSidebar";
// Reuses the client portal's page/shell/main primitives (.client-page,
// .client-shell, .client-main*) — generic layout, not client-specific.
import "../CRMDashboard.css";
import "../client/clientTheme.css";
import "../client/ClientLayout.css";

const THEME_KEY = "polyp_theme";

export default function LeagueLayout() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(THEME_KEY) || "dark";
  });

  useEffect(() => {
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <div className={`client-page${theme === "light" ? " light-theme" : ""}`}>
      <div className="client-shell">
        <LeagueSidebar theme={theme} onToggleTheme={toggleTheme} />
        <main className="client-main">
          <div className="client-main-inner">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
